<div class="single-page">
    <div class="carousel">
        <app-carousel></app-carousel>
    </div>
        <app-change-password class="content"></app-change-password>
</div>
<app-auth-footer></app-auth-footer>
